import { init } from '@nosto/preact';
import { Serp, Category, Autocomplete, History } from './components';
import { defaultConfig } from './config';

import './styles/index.css';

init({
  ...window.nostoTemplatesConfig,
  serpComponent: Serp,
  historyComponent: History,
  autocompleteComponent: Autocomplete,
  categoryComponent: Category,
  formCssSelector:
    '.header-item--search-bar > .small--hide > form[action="/search"][method="get"][role="search"], .input-group.search-bar.mobile-header-menu',
  inputCssSelector:
    '#Search, .input-group.search-bar.mobile-header-menu > .input-group-field',
  contentCssSelector: '#MainContent',
  // '.gc_product_data .page-width .gc_product_grid_main.acl_paging_items--wrapper',
  serpUrlMapping: {
    query: 'q',
    'products.filter': 'filter',
    'products.page': 'page',
    'products.sort': 'sort',
  },
  // Uncomment to redirect to search page instead of rendering on the same page
  serpPath: '/search',

  // Uncomment to redirect to search page instead of rewriting browser history
  serpPathRedirect: true,
  serpQuery: {
    products: {
      fields: [
        'productId',
        'url',
        'name',
        'imageUrl',
        'thumbUrl',
        'description',
        'brand',
        'availability',
        'price',
        'priceText',
        'listPrice',
        'ratingValue',
        'reviewCount',
        'tags1',
        'skus.id',
        'skus.name',
        'skus.availability',
        'skus.customFields.key',
        'skus.customFields.value',
        'customFields.key',
        'customFields.value',
      ],
      facets: ['*'],
      size: defaultConfig.serpSize,
      from: 0,
    },
  },
  autocompleteQuery: {
    products: {
      fields: [
        'productId',
        'url',
        'name',
        'imageUrl',
        'thumbUrl',
        'brand',
        'availability',
        'price',
        'priceText',
        'listPrice',
        'ratingValue',
        'reviewCount',
        'tags1',
      ],
      size: defaultConfig.autocompleteProductsSize,
    },
    keywords: {
      fields: ['keyword', '_highlight.keyword'],
      size: defaultConfig.autocompleteKeywordsSize,
      facets: ['*'],
    },
  },
  compressUrlParameters: true,
  fallback: true,
  // queryModifications(query) {
  //   return {
  //       ...query,
  //       products: {
  //           ...(query.products ?? {}),
  //           filter: [
  //               ...(query.products.filter ?? []),
  //               {
  //                   field: "skus.availability",
  //                   value: ["InStock"]
  //               }
  //           ]
  //       }
  //   }
  // },
  // Uncomment for Category Merchandising
  categoryCssSelector: '.collection-content',
  categoryQuery() {
    return {
      name: 'category',
      products: {
        categoryId: this.categoryId(),
        categoryPath: this.categoryPath(),
        size: defaultConfig.serpSize,
        from: 0,
      },
    };
  },
});
